import { render, staticRenderFns } from "./HomeLink.vue?vue&type=template&id=7955a949&scoped=true&"
import script from "./HomeLink.vue?vue&type=script&lang=js&"
export * from "./HomeLink.vue?vue&type=script&lang=js&"
import style0 from "./HomeLink.vue?vue&type=style&index=0&id=7955a949&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7955a949",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7955a949')) {
      api.createRecord('7955a949', component.options)
    } else {
      api.reload('7955a949', component.options)
    }
    module.hot.accept("./HomeLink.vue?vue&type=template&id=7955a949&scoped=true&", function () {
      api.rerender('7955a949', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/HomeLink.vue"
export default component.exports